import {gql} from '@apollo/client';

export const CREATE_PICKUP_TASK_WITH_APPOINTMENTS = gql`
  mutation PickupTaskMutation($input: PickupTaskInput!) {
    createPickupTaskWithAppointments(input: $input)
  }
`;